import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import { setInLocal, buildPerksHTMLforTrip } from "../../utils/app-helpers";
import Banners from "../partials/banners";
import BookmarkArrow from "../partials/bookmark-arrow";
import CouponReminder from "../partials/coupon-reminder";
import SiteFooter from "../partials/site-footer";
import HelmetWrapper from "../partials/helmet-wrapper";
import MonthlyPaymentsCallout from "../partials/monthly-payments-callout";
import PriceGuarantee from "../partials/price-guarantee";
import SiteHeader from "../partials/site-header";
import TabbedContent from "../partials/tabbed-content";
import ThinBar from "../partials/thin-bar";
import TripHeader from "../partials/trip-header";

const { siteMetadata: config } = GatsbyConfig;

export default class PricesPage extends React.Component {
  componentDidMount() {
    const { trip } = this.props;

    setInLocal("lsg.last-viewed-trip", trip);
  }

  render() {
    const { trip, location } = this.props;
    if (!trip) return <main />;
    const tripData = config.trips[trip];
    const perksHTML = buildPerksHTMLforTrip(tripData);
    const selectedKey =
      location && location.search.match(/tab=[^&]+/i)
        ? location.search.replace(/.*\??tab=([^&]+).*/g, "$1")
        : "rooms";
    const title = "Prices";
    const description =
      "Check out the room categories available and prices.  We have affordable " +
      "monthly payment plans available.";

    const { roomsLabel = "Rooms", suitesLabel = "Suites" } = tripData;

    return (
      <div className={`page-prices trip-${trip}`}>
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        <div className="bookmark" id="top" />
        <SiteHeader trip={trip} step="1" />
        <TripHeader trip={trip} />
        <CouponReminder trip={trip} />
        <main>
          <div
            style={{
              backgroundImage: `url(/images/prices-${trip}-splash.jpg)`,
            }}
            className="image mobile-100x40 desktop-300"
          />
          <Banners trip={trip} />
          {tripData.thinBar2 && !tripData.soldOut ? (
            <ThinBar message={tripData.thinBar2} />
          ) : (
            ""
          )}
          <TabbedContent
            willAnchor
            replaceState={`/${trip}/prices/`}
            selectedKey={selectedKey}
            data={JSON.stringify([
              {
                key: "rooms",
                name: roomsLabel,
                slug: "",
                component: "Rooms",
                props: { trip, kind: "room" },
              },
              {
                key: "suites",
                name: suitesLabel,
                slug: "?tab=suites",
                component: "Rooms",
                props: { trip, kind: "suite" },
              },
              {
                key: "all",
                name: "All",
                slug: "?tab=all",
                component: "Rooms",
                props: { trip },
              },
            ])}
          />
          <MonthlyPaymentsCallout
            trip={trip}
            monthlyDisabled={tripData.disableMonthlyPaymentOption}
            validUntil={
              tripData.disableMonthlyPaymentOption
                ? tripData.availabilityCutoff
                : undefined
            }
          />
          <div className="room-perks">
            <div className="wrap">
              <div className="whats-included">
                <h3>What’s Included</h3>
                <div dangerouslySetInnerHTML={{ __html: perksHTML }} />
              </div>
            </div>
          </div>
          <div className="content">
            <div className="wrap">
              <p>
                {tripData.disableMonthlyPaymentOption
                  ? config.doubleOccupancyDisclaimerNoMonthly
                  : config.doubleOccupancyDisclaimer}
              </p>
            </div>
            <div className="wrap arrow-bar">
              <BookmarkArrow bookmark="top" direction="up" />
            </div>
          </div>
        </main>
        <SiteFooter trip={trip} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/prices.js